import { apiClient } from './apiClient';
import { Contract, ContractStatus, CreateContractRequest, UpdateContractRequest } from '../types/contract';

export const contractService = {
  getPaginated: async (
    companyId: string,
    params: URLSearchParams
  ): Promise<any> => {
    const response = await apiClient.get(`/companies/${companyId}/contracts/paginated?${params}`);
    return response.data;
  },

  getById: async (companyId: string, contractId: string): Promise<Contract> => {
    const response = await apiClient.get(`/companies/${companyId}/contracts/${contractId}`);
    return response.data;
  },

  create: async (companyId: string, payload: CreateContractRequest): Promise<Contract> => {
    const response = await apiClient.post(`/companies/${companyId}/contracts`, payload);
    return response.data;
  },

  update: async (companyId: string, contractId: string, payload: UpdateContractRequest): Promise<Contract> => {
    const response = await apiClient.put(`/companies/${companyId}/contracts/${contractId}`, payload);
    return response.data;
  },

  delete: async (companyId: string, contractId: string): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/contracts/${contractId}`);
  },

  uploadFile: async (companyId: string, contractId: string, file: File): Promise<Contract> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/companies/${companyId}/contracts/${contractId}/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  downloadFile: async (companyId: string, contractId: string): Promise<Blob> => {
    const response = await apiClient.get(`/companies/${companyId}/contracts/${contractId}/file`, {
      responseType: 'blob'
    });
    return response.data;
  },

  deleteFile: async (companyId: string, contractId: string): Promise<Contract> => {
    const response = await apiClient.delete(`/companies/${companyId}/contracts/${contractId}/file`);
    return response.data;
  }
};

export const ContractStatusLabels: Record<ContractStatus, string> = {
  [ContractStatus.DRAFT]: 'Черновик',
  [ContractStatus.ACTIVE]: 'Активен',
  [ContractStatus.EXPIRED]: 'Истек',
  [ContractStatus.TERMINATED]: 'Расторгнут'
};

